module.exports = __webpack_public_path__ + "img/wood.b4e9ec1b.svg";